module.exports = __webpack_public_path__ + "static/media/checkAction.21b83b61.svg";